import React, { Component } from 'react';
import { Route } from 'react-router-dom';
import PropTypes from 'prop-types';

class MeterReadingButton extends Component {
  constructor(props) {
    super(props);

    this.handleClick = this.handleClick.bind(this);
  }

  handleClick(history) {
    history.push({
      pathname: `/orders/${this.props.orderId}/fulfill`,
      state: { fboId: this.props.fboId }
    });
  }

  render() {
    return (
      <Route render={({ history }) => (
        <div className="action left">
          <button
            className="btn btn-small btn-primary-outline"
            onClick={() => this.handleClick(history)}
          >
            Fulfill
          </button>
        </div>
      )}
      />
    );
  }
}


MeterReadingButton.propTypes = {
  fboId: PropTypes.number.isRequired,
  orderId: PropTypes.number.isRequired,
};

export default MeterReadingButton;




// WEBPACK FOOTER //
// ./src/Containers/Orders/ActionButtons/MeterReadingButton.js